import { observable } from 'mobx';

const RefundDetailModel = observable({
    taxRefundApplication: {
        provisionalRefund : {
            provisionalRefundAmount : "",
            provisionalRefundCommissionRate : ""
        },
        provisionalCarryforward: {
            provisionalCarryforwardAmount : "",
            provisionalCarryforwardCommissionRate : ""
        },
        businessName : "",
        taxRefundStatusType : "",
        taxRefundLastStepType: "",
        canProvideService: null,
        acceptAt: "",
        actualRefundAmount: "",
        actualCarryforwardAmount: "",
        refundAmount: "",
        refundCommissionRate: "",
        carryforwardAmount: "",
        carryforwardCommissionRate: "",
        discountAmount: "",
        discountRate: "",
        discountType: "",
        retainedAmount: "",
        depositAt: "",
        refundBank: "",
        refundAccount: "",
        refundAccountHolder: ""
    },
    representatives: [],
    personInCharges: []
});

export default RefundDetailModel;